import React from "react";
import NotificationsRouter from './Notification/Router';
export { getFields, getReplyFields } from './Notification/Router';

export default function NotificationSupplierRouter(props) {
    return (
        <NotificationsRouter {...props} mode='SUPPLIER' />
    );
};
